var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6654 14.3385C25.6654 7.89854 20.4387 2.67188 13.9987 2.67188C7.5587 2.67188 2.33203 7.89854 2.33203 14.3385C2.33203 19.9852 6.34537 24.6869 11.6654 25.7719V17.8385H9.33203V14.3385H11.6654V11.4219C11.6654 9.17021 13.497 7.33854 15.7487 7.33854H18.6654V10.8385H16.332C15.6904 10.8385 15.1654 11.3635 15.1654 12.0052V14.3385H18.6654V17.8385H15.1654V25.9469C21.057 25.3635 25.6654 20.3935 25.6654 14.3385Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.fb09275d3a28b5aea39f88e77930e8c1.svg";
export { ForwardRef as ReactComponent };